import StartWizard from "../auto/start/StartWizard";
import VerifyPhone from "../auto/verify/VerifyPhone";
import CodeEntry from "../auto/passCode/CodeEntry";
import VehiclesWizard from "../auto/vehicles/VehiclesWizard";
import DriversWizard from "../auto/drivers/DriversWizard";
import DiscountFields from "../auto/discounts/DiscountFields";
import Continue from "./Continue";
import DetailsContainer from "../home/details/DetailsContainer";
import DiscountsForm from "../home/discounts/DiscountsForm";
import InsuredContainer from "../home/insured/InsuredForm";
import ContactForm from "../contact/ContactForm";
import Quotes from "../quotes/QuotesContainer";
import SelectedQuote from "../selectedQuote/SelectedQuoteContainer";
import { HydrateQuote } from "../hydrate/HydrateQuote";

export const BundleWizardPages = {
  bundleWizardStart: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/start",
    type: "PAGE_BUNDLE_WIZARD_START",
    view: StartWizard,
  },
  autoWizardVerify: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/verify",
    type: "BUNDLE_PAGE_VERIFY_CODE",
    view: VerifyPhone,
  },
  autoCodeEntry: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/code-entry",
    type: "BUNDLE_PAGE_CODE_ENTRY",
    view: CodeEntry,
  },
  bundleWizardVehicles: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/vehicles",
    type: "PAGE_BUNDLE_WIZARD_VEHICLES",
    view: VehiclesWizard,
  },
  bundleWizardDrivers: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/drivers",
    type: "PAGE_BUNDLE_WIZARD_DRIVERS",
    view: DriversWizard,
  },
  bundleWizardAutoDiscounts: {
    pathExact: true,
    anon: true,
    // TODO: update url when figure out how discounts is working for auto/home bundle
    path: "/bundle/wizard/auto-discounts",
    type: "PAGE_BUNDLE_WIZARD_DISCOUNT",
    view: DiscountFields,
  },
  bundleWizardContinue: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/continue",
    type: "PAGE_BUNDLE_WIZARD_CONTINUE",
    view: Continue,
  },
  bundleWizardDetails: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/details/form",
    type: "PAGE_BUNDLE_WIZARD_DETAILS_FORM",
    view: DetailsContainer,
  },
  bundleWizardDetailsConfirm: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/details/confirm",
    type: "PAGE_BUNDLE_WIZARD_DETAILS_CONFIRM",
    view: DetailsContainer,
  },
  bundleWizardHomeDiscounts: {
    pathExact: true,
    anon: true,
    // TODO: update url when figure out how discounts is working for auto/home bundle
    path: "/bundle/wizard/home-discounts",
    type: "PAGE_BUNDLE_WIZARD_DISCOUNTS",
    view: DiscountsForm,
  },
  bundleWizardInsured: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/insured",
    type: "PAGE_BUNDLE_WIZARD_INSURED",
    view: InsuredContainer,
  },
  bundleWizardContact: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/contact",
    type: "PAGE_BUNDLE_WIZARD_CONTACT",
    view: ContactForm,
  },
  bundleWizardQuotes: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/quotes",
    type: "PAGE_BUNDLE_WIZARD_QUOTES",
    view: Quotes,
  },
  bundleWizardSelectedQuote: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/quotes/:id",
    type: "PAGE_BUNDLE_WIZARD_QUOTES",
    view: SelectedQuote,
  },
  bundleWizardHydrateQuote: {
    pathExact: true,
    anon: true,
    path: "/bundle/wizard/hydrate-quote/:id",
    type: "PAGE_BUNDLE_WIZARD_HYDRATE",
    view: HydrateQuote,
  },
};

export default BundleWizardPages;
